import { render, staticRenderFns } from "./UserPropListPanel.vue?vue&type=template&id=81351628&scoped=true"
import script from "./UserPropListPanel.vue?vue&type=script&lang=js"
export * from "./UserPropListPanel.vue?vue&type=script&lang=js"
import style0 from "./UserPropListPanel.vue?vue&type=style&index=0&id=81351628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81351628",
  null
  
)

export default component.exports